"use client";

import { c as _c } from "react/compiler-runtime";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import Button from "@/components/ui/button";
interface GroupPaginationProps {
  /** Current page number (1-indexed) */
  currentPage: number;
  /** Total number of pages */
  totalPages: number;
  /** Total items in the group */
  totalItems: number;
  /** Items per page */
  pageSize: number;
  /** Callback when page changes */
  onPageChange: (page: number) => void;
  /** Whether a page is currently loading */
  isLoading: boolean;
  /** Label for items (e.g., "providers", "transactions") */
  itemLabel: string;
}

/**
 * Inline pagination controls for within a group.
 * Shows "Showing X-Y of Z items" with prev/next buttons.
 */
export function GroupPagination(t0) {
  const $ = _c(35);
  const {
    currentPage,
    totalPages,
    totalItems,
    pageSize,
    onPageChange,
    isLoading,
    itemLabel
  } = t0;
  const start = (currentPage - 1) * pageSize + 1;
  const end = Math.min(currentPage * pageSize, totalItems);
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === totalPages;
  let t1;
  if ($[0] !== start) {
    t1 = start.toLocaleString();
    $[0] = start;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== end) {
    t2 = end.toLocaleString();
    $[2] = end;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== totalItems) {
    t3 = totalItems.toLocaleString();
    $[4] = totalItems;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== itemLabel || $[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <span className="text-foreground-secondary">Showing {t1}-{t2} of{" "}{t3} {itemLabel}</span>;
    $[6] = itemLabel;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== currentPage || $[12] !== onPageChange) {
    t5 = () => onPageChange(currentPage - 1);
    $[11] = currentPage;
    $[12] = onPageChange;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = isFirstPage || isLoading;
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <HiChevronLeft className="h-4 w-4" />;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t5 || $[16] !== t6) {
    t8 = <Button variant="ghost" size="sm" onClick={t5} disabled={t6} aria-label="Previous page">{t7}</Button>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== currentPage || $[19] !== totalPages) {
    t9 = <span className="px-2 text-foreground-secondary">Page {currentPage} of {totalPages}</span>;
    $[18] = currentPage;
    $[19] = totalPages;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== currentPage || $[22] !== onPageChange) {
    t10 = () => onPageChange(currentPage + 1);
    $[21] = currentPage;
    $[22] = onPageChange;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const t11 = isLastPage || isLoading;
  let t12;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <HiChevronRight className="h-4 w-4" />;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t11) {
    t13 = <Button variant="ghost" size="sm" onClick={t10} disabled={t11} aria-label="Next page">{t12}</Button>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13 || $[29] !== t8 || $[30] !== t9) {
    t14 = <div className="flex items-center gap-1">{t8}{t9}{t13}</div>;
    $[28] = t13;
    $[29] = t8;
    $[30] = t9;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t14 || $[33] !== t4) {
    t15 = <div className="flex items-center justify-between border-t border-border bg-background-secondary px-4 py-2 text-body">{t4}{t14}</div>;
    $[32] = t14;
    $[33] = t4;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
}